export default __webpack_public_path__ + "images/0xad531012c0651a85a212f10fc97b3ec15684548a.png";